import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Components
import Page from './page';


// Exports
export default class FilterablePage extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    query: PropTypes.object.isRequired,
    configureFilters: PropTypes.func.isRequired,
    search: PropTypes.func.isRequired
  };

  componentWillMount() {
    const { query, configureFilters, search } = this.props;
    const setDefaultQuery = query.setDefaultQuery === 'true';

    // Configure the filters for the page
    configureFilters(setDefaultQuery);

    // Don't search if setDefaultQuery was true, because otherwise we will immediately search twice
    // and sometimes the first search results will come back second and the results will not match the
    // filters which are being displayed
    if (!setDefaultQuery) search(query);
  }

  componentWillReceiveProps(nextProps) {
    const { configureFilters, search } = this.props;
    const setDefaultQuery = nextProps.query.setDefaultQuery === 'true';
    
    const nextQuery = _.omit(nextProps.query, 'setDefaultQuery');
    const currentQuery = _.omit(this.props.query, 'setDefaultQuery');

    if (setDefaultQuery) {
      // Reconfigure filters if setDefaultQuery was true
      configureFilters(setDefaultQuery);
    } else if (!_.isEqual(nextQuery, currentQuery)) {
      // Search again if the query or pager has been updated
      search(nextProps.query);
    }
  }

  render() {
    const { children, ...props } = this.props;
    const passedProps = _.omit(props, 'query', 'configureFilters', 'search');

    return (
      <Page {...passedProps}>
        {children}
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/page/filterable-page.js